// extracted by mini-css-extract-plugin
export default {"Root":"ConfirmDialog_Root__scos+","Content":"ConfirmDialog_Content__ERJfD"};